import { Controller } from "@hotwired/stimulus"
import { logger } from "../logger"

// Handles links that should request Turbo Stream responses
// Sets the correct Accept header for Turbo Stream format
export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    // Ensure the link has the URL value
    if (!this.hasUrlValue && this.element.href) {
      this.urlValue = this.element.href
    }
  }

  click(event) {
    // Only handle if this is the actual link element or a child that should trigger it
    const link = event.target.closest('a')
    if (!link || link !== this.element) {
      return
    }

    event.preventDefault()

    const url = this.urlValue || this.element.href
    if (!url) {
      return
    }

    // Make fetch request with Turbo Stream Accept header
    fetch(url, {
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
      },
      credentials: 'same-origin'
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.text()
    })
    .then(html => {
      // Turbo automatically processes turbo-stream elements when they're added to the DOM
      // Create a temporary container and append the HTML
      const tempContainer = document.createElement('template')
      tempContainer.innerHTML = html
      
      // Append each turbo-stream element to the document so Turbo processes it
      const streamElements = tempContainer.content.querySelectorAll('turbo-stream')
      streamElements.forEach(element => {
        document.body.appendChild(element)
      })
    })
    .catch(error => {
      logger.error('Error loading Turbo Stream:', error)
    })
  }
}

